import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

import Selector from "../../../Selector";

function SearchRegionField({
   mainGroup,
   className,
}) {

   const {filterRegionState, branchRegions, filterState} = useSelector(({branches}) => branches)

   const {branches} = useDispatch()

   const setFilteredBranchRegions = (payload) => branches.setFilteredRegions(payload);

   useEffect(() => {
      branches.setFilteredRegionsAsync();
   }, [branches])

   const regionOptionsSelect =  branchRegions.map(({region}) => region === null
         ? { label: "REGIÃO NÃO ATRIBUÍDA", value: "others" }
         : { label: `${region}`, value: region }
      )

   regionOptionsSelect.unshift({ label: "TODAS AS REGIONAIS - FBZ", value: "allFbz" });
   regionOptionsSelect.unshift({ label: "TODAS AS REGIÕES", value: "all" });

   return (
      ["support", "backoffice"].includes(mainGroup) && (
         <Selector
            className={className}
            options={regionOptionsSelect}
            isOptionDisabled={(option) =>
               {
                  if(filterRegionState.find(selectedOption => selectedOption.value === 'all')) {
                     switch (option.value) {
                        case "allFbz":
                        case "TORRE FBZ - GO":
                        case "TORRE FBZ - MT NORTE":
                        case "TORRE FBZ - MT SUDOESTE":
                        case "TORRE FBZ - NORDESTE":
                        case "TORRE FBZ - SUL":
                        case "TORRE FBZ - CNH":
                        case "TORRE CROP INPUT BR":
                        case "TORRE COTTON BR":
                        case "TORRE AMIDOS BR":
                           return true;
                        default:
                           return false;
                     }
                  }

                  if(filterRegionState.find(selectedOption => selectedOption.value === 'allFbz')) {
                     switch (option.value) {
                        case "all":
                        case "TORRE FBZ - GO":
                        case "TORRE FBZ - MT NORTE":
                        case "TORRE FBZ - MT SUDOESTE":
                        case "TORRE FBZ - NORDESTE":
                        case "TORRE FBZ - SUL":
                           return true;
                        default:
                           return false;
                     }
                  }

                  if(filterRegionState.find(selectedOption => selectedOption.value !== 'all' && selectedOption.value !== 'others')) {
                     switch (option.value) {
                        case "all":
                           return true;
                        default:
                           return false;
                     }
                  }
               }
            }
            label="Selecionar a Região Cargill"
            isMulti
            placeholder="Digite ou busque a região..."
            value={filterRegionState}
            onChange={(value) => {
               Array.isArray(value) ?
               setFilteredBranchRegions(value) :
                  value ? setFilteredBranchRegions([value]) : setFilteredBranchRegions([])
            }}
            defaultValue={regionOptionsSelect.length === 1 && regionOptionsSelect[0]}
            width="400px"
            isDisabled={filterState.length && !filterRegionState.length}
            data-cy="tabHeader-filterRegion-select"
            id="tabHeader-filterRegion-select"
         />
      )
   );
}

SearchRegionField.propTypes = {
   mainGroup: PropTypes.string.isRequired,
   className: PropTypes.string.isRequired
};

SearchRegionField.defaultProps = {};

export default SearchRegionField;
